module.exports = {"540424100":"扎木镇","540424101":"倾多镇","540424102":"松宗镇","540424200":"古乡","540424201":"玉许乡","540424202":"多吉乡","540424203":"康玉乡","540424204":"玉普乡","540424205":"易贡乡","540424206":"八盖乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540424.json
// module id = 2524
// module chunks = 0